import React from 'react';
import logo from '../../images/logo_purple.png';
import boxMobile from '../../images/boxMobile.png';
import { CustomLabel, CustomButton } from "@tracknme/material-ui";
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';
import * as Actions from '../../store/actions';
import '../../mobile.css';

function Step2() {

  const dispatch = useDispatch();

  function changeNextStepValue() {
    dispatch(Actions.setStep(2));
  }

  return (
    <div className="menuMobile">
        <div className="containerMobile">
      
           <div className="containerImage" >
              <img src={logo} className="logo" alt="Trackn'Me" />
           </div>
           <div className="title" >
            <CustomLabel label="Tenha acesso a todos os produtos da Track’nMe!" color="initial" component="h4" variant="h4" style={{fontSize:24, fontWeight:600}} />  
           </div>

           <div className="subtitle" >
            <CustomLabel  label="Tenha tudo o que você precisa para operar sua empresa de rastreamento, incluindo sistema de cobrança." color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:400, color:"#888888"}} />  
           </div>

          <img src={boxMobile} className="boxImage" alt="nick" /> 

          <div style={{height:100,marginTop:50}}></div>
          
        </div>

       
        
        <div className="footer">
          <Grid container spacing={1}>
            <Grid item xs={4} ></Grid>
            <Grid item xs={4} >
              <div className="align">
                <CustomLabel  label=" Passo 1 – 6" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:400, color:'#929292',marginTop:22}} />  
              </div>
            </Grid>
            <Grid item xs={4} >
            <div className="align"><CustomButton   disabled={false} onClick={() => changeNextStepValue()} variant="contained" color="primary" label="Avançar" style={{height:'40px',marginLeft:8,marginTop:10}}/> </div>
            </Grid>
          </Grid>
          
        </div>
        
     </div>
    
  );
}

export default Step2;

